import React, { useState, useMemo, Fragment, memo } from "react";
import _, { isArray } from "lodash";
import {
  useFilters,
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";
import classNames from "classnames";
import { getCurrentLocalDateTime } from "../../utils/getLocalDateTime";
import { format } from "date-fns";
import PrevPage from "../Pagination/PrevPage";
import NumberPage from "../Pagination/NumberPage";
import NextPage from "../Pagination/NextPage";
import SelectRows from "../Pagination/SelectRows";

const Row = memo(({ row, i }) => {
  return (
    <Fragment>
      <tr
        {...row.getRowProps()}
        className={classNames(
          "cursor-pointer hover:bg-blueGray-200 transition-all duration-300",
          {
            "bg-white": i % 2 === 0,
            "bg-gray-100": i % 2 !== 0,
          }
        )}
      >
        {row.cells.map((cell, index) => {
          return (
            <td
              className={"p-4 text-gray-700 text-sm text-center"}
              {...cell.getCellProps()}
            >
              {cell.render("Cell")}
            </td>
          );
        })}
      </tr>
    </Fragment>
  );
});

function BroadCastTable({ data, getData, query, setSelectedRows }) {
  const columns = useMemo(() => {
    let localColumn = [
      {
        Header: "เบอร์โทร",
        accessor: "phone_number",
        Cell: ({ row }) => {
          return <div>{`${row.values.phone_number}`}</div>;
        },
      },
      {
        Header: "ชื่อ",
        accessor: "name",
      },
      {
        Header: "นามสกุล",
        accessor: "lastname",
      },
      {
        Header: "ยอดเงิน",
        accessor: "amount",
      },
      {
        Header: "ยอดคงค้าง",
        accessor: "totalDue",
      },
      {
        Header: "จำนวนวัน",
        accessor: "duration",
      },
      {
        Header: "วันที่",
        accessor: "date",
        Cell: () => {
          return <div>{format(new Date(), "dd/MM/yyyy")}</div>;
        },
      },
    ];

    if (query?.type === "debtor") {
      localColumn = localColumn?.filter(
        (column) => !["amount", "date"].includes(column.accessor)
      );
    } else {
      localColumn = localColumn?.filter(
        (column) =>
          !["totalDue", "lastname", "duration"].includes(column.accessor)
      );
    }

    return localColumn;
  }, [query]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,

    page, // Instead of using 'rows', we'll use page,
    // which has only the rows for the active page

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,

    state: { pageIndex, pageSize, globalFilter },
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    { columns, data },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <div className="mx-4 mb-2">
      <div className="bg-white rounded border border-gray-300 w-full overflow-x-auto ">
        <table {...getTableProps()} className="w-full whitespace-no-wrap">
          <thead className=" text-sm font-semibold tracking-wide text-gray-500  border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, i) => (
                  <th
                    {...column.getHeaderProps()}
                    className={classNames("px-4 py-3 text-center", {
                      "rounded-tl": i === 0,
                      "rounded-tr": i === headerGroup.headers.length - 1,
                    })}
                  >
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800 text-gray-700 dark:text-gray-400"
            {...getTableBodyProps()}
          >
            {rows.map((row, i) => {
              prepareRow(row);
              return (
                <Row
                  key={row.getRowProps().key}
                  i={i}
                  row={row}
                  value={data[i]}
                />
              );
            })}
          </tbody>
        </table>
      </div>
      {/* <div className="mt-4 flex justify-between ">
        <nav
          className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
          aria-label="Pagination"
        >
          <PrevPage
            onClick={() => previousPage()}
            canPreviousPage={canPreviousPage}
          />
          {pageOptions.map((row, i) => {
            return (
              <NumberPage
                number={i}
                pageIndex={pageIndex}
                gotoPage={gotoPage}
              />
            );
          })}
          <NextPage onClick={() => nextPage()} canNextPage={canNextPage} />
        </nav>
        <div className="w-24 flex">
          <SelectRows
            pageSize={pageSize}
            options={[
              { label: "50", value: 50 },
              { label: "100", value: 100 },
            ]}
            onChange={(e) => setPageSize(e)}
          />
        </div>
      </div> */}
    </div>
  );
}

export default BroadCastTable;
